import { createEnv } from '@t3-oss/env-core';
import { z } from 'zod';

export default createEnv({
  client: {
    PUBLIC_DANGEROUS_KILL_SEO: z.string().default('false'),

    PUBLIC_SITE_CODE: z.string().default('jsn'),

    PUBLIC_HTTP_SCHEME: z.enum(['https', 'http']).default('https'),
    PUBLIC_SITE_DOMAIN: z.string(),

    PUBLIC_RZP_KEY_ID: z.string(),

    PUBLIC_ZIINA_TEST_MODE: z
      .union([z.string(), z.boolean()])
      .optional()
      .default('false')
      .transform((val) => (typeof val === 'boolean' ? val : val === 'true')),

    PUBLIC_GOOGLE_KEY: z.string(),

    PUBLIC_GTM_ID: z.string().optional(),
    PUBLIC_GA_MEASUREMENT_ID: z.string().optional(),
    PUBLIC_FB_PIXEL_ID: z.string().optional(),

    PUBLIC_LOG_LEVEL: z.enum(['error', 'warn', 'info', 'verbose', 'debug']).default('info'),

    PUBLIC_NODE_ENV: z.enum(['development', 'preview', 'production']).default('production'),

    PUBLIC_SHOW_COUNTRY_SELECTOR: z.string().default('false'),

    PUBLIC_SERVICE_NAME: z.string().default('jigsawnation'),

    PUBLIC_LAST9_RUM_ENDPOINT: z.string().optional(),
    PUBLIC_LAST9_CLIENT_TOKEN: z.string().optional(),

    PUBLIC_INTERAKT_TOKEN: z.string().optional(),
    PUBLIC_KLAVIYO_ID: z.string().optional(),

    PUBLIC_VERSION: z.string().default('1.0.0'),

    PUBLIC_SALEOR_API_URL: z.string(),
  },
  clientPrefix: 'PUBLIC_',

  runtimeEnv: typeof window === 'undefined' ? process.env : window.env,

  isServer: typeof window === 'undefined',
});
